<template>
  <div class="greetings home__section">
    <h2 class="greetings__title">歡迎來到空英老師專區！</h2>
    <p>空英老師專區提供給每位使用空中英語教室系列雜誌的教師，進行延伸教學及課堂評量，成為最完整的教學資源。</p>
    <p>您可按照教學上的需要，選擇當月全部下載，或是依照年月份選擇個別下載。</p>
  </div>
</template>

<script>
export default {
  //
}
</script>
